import React, { useEffect, useState } from "react";
import {
  Form,
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  Modal,
} from "react-bootstrap";
import axios from "axios";
import PageLayout from "../../../layouts/PageLayout";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import GalleryUpload from "./GalleryUpload";
import Select from "react-select";

export default function AddReligiousAffiliation() {
  const [families, setFamilies] = useState([]);

  const [faiths, setFaiths] = useState([]);
  const [prayerPlaces, setPrayerPlaces] = useState([]);

  const [religiousAffiliationId, setReligiousAffiliationId] =
    useState(null);

  const [selectedVideo, setSelectedVideo] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [videoUploading, setVideoUploading] = useState(false);

  const [formErrors, setFormErrors] = useState({});

  const [form, setForm] = useState({
    person_id: "",

    faith_id: "",
    place_id: "",
    baptized: 0,
    comments: "",
  });
  const [showPrayerPlaceModal, setShowPrayerPlaceModal] = useState(false);
  const [newPrayerPlace, setNewPrayerPlace] = useState({
    faith_id: "",
    palace_name: "",
    master: "",
    address: "",
  });
  const AuthToken = localStorage.getItem("AuthUser");

  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${AuthToken}`;

  useEffect(() => {
    fetchInitialData();
  }, []);

  /*
  |--------------------------------------------------------------------------
  | Initial Data
  |--------------------------------------------------------------------------
  */

  const fetchInitialData = async () => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL +
        "/initial-religious-affiliations-data"
      );

      setFamilies(res.data.people || []);
      setFaiths(res.data.faiths || []);
      setPrayerPlaces(res.data.places || []);
    } catch (error) {
      console.error(error);

      Swal.fire({
        title: "Error!",
        text: "Failed to load initial data.",
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  /*
  |--------------------------------------------------------------------------
  | Family Options
  |--------------------------------------------------------------------------
  */

  const familyOptions = families.map((f) => ({
    value: f.person_id,
    label: `${f.f_number} - ${f.beneficiary_name} (${f.city_name})`,
  }));

  /*
  |--------------------------------------------------------------------------
  | Family Change
  |--------------------------------------------------------------------------
  */



  /*
  |--------------------------------------------------------------------------
  | General Change
  |--------------------------------------------------------------------------
  */
  const handleChange = (e, fieldName = null) => {
    // react-select
    if (fieldName) {
      setForm((prev) => ({
        ...prev,
        [fieldName]: e?.value || "",
        ...(fieldName === "faith_id" && {
          place_id: "",
        }),
      }));

      return;
    }

    // Normal input/select
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "faith_id" && {
        place_id: "",
      }),
    }));
  };


  const filteredPrayerPlaces = prayerPlaces.filter(
    (place) => Number(place.faith_id) === Number(form.faith_id)
  );
  /*
  |--------------------------------------------------------------------------
  | Validation
  |--------------------------------------------------------------------------
  */

  const validate = () => {
    const errors = {};

    if (!form.person_id) {
      errors.person_id = "Family is required";
    }



    if (!form.faith_id) {
      errors.faith_id = "Faith is required";
    }

    if (!form.place_id) {
      errors.place_id = "Prayer place is required";
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  /*
  |--------------------------------------------------------------------------
  | Submit
  |--------------------------------------------------------------------------
  */

  const submitForm = async (e) => {
    e.preventDefault();

    if (!validate()) {
      Swal.fire({
        title: "Error!",
        text: "Please fix the errors in the form.",
        icon: "error",
        confirmButtonText: "Ok",
      });

      return;
    }

    try {
      const data = new FormData();

      data.append("person_id", form.person_id);
      data.append("place_id", form.place_id);
      data.append("baptized", form.baptized);
      data.append("comments", form.comments);

      const response = await axios.post(
        process.env.REACT_APP_API_URL +
        "/religious-affiliations",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      /*
       * Save returned ID.
       * Gallery and video will use this ID.
       */
      setReligiousAffiliationId(
        response.data.data.id
      );

      Swal.fire({
        title: "Success!",
        text:
          "Religious affiliation saved successfully. You can now upload pictures and video.",
        icon: "success",
        confirmButtonText: "Ok",
      });

      setForm({
        person_id: "",
        faith_id: "",
        place_id: "",
        baptized: 0,
        comments: "",
      });
    } catch (error) {
      console.error(error);

      Swal.fire({
        title: "Error!",
        html: `
    <p>${error?.response?.data?.message || "Failed to save religious affiliation."}</p>

    ${error?.response?.data?.errors
            ? `
          <ul style="text-align: left; margin-top: 10px;">
            ${Object.values(error.response.data.errors)
              .flat()
              .map((message) => `<li>${message}</li>`)
              .join("")}
          </ul>
        `
            : ""
          }
  `,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const savePrayerPlace = async () => {
    try {
      if (
        !newPrayerPlace.faith_id ||
        !newPrayerPlace.palace_name ||
        !newPrayerPlace.master ||
        !newPrayerPlace.address
      ) {
        Swal.fire({
          title: "Error!",
          text: "Please fill all prayer place fields.",
          icon: "error",
        });

        return;
      }

      const res = await axios.post(
        process.env.REACT_APP_API_URL +
        "/religious-affiliations/prayer-places",
        newPrayerPlace
      );

      const created = res.data.data;

      // Add new place to dropdown
      setPrayerPlaces((prev) => [
        ...prev,
        created,
      ]);

      // Automatically select newly created place
      setForm((prev) => ({
        ...prev,
        place_id: created.id,
      }));

      // Reset modal
      setNewPrayerPlace({
        faith_id: "",
        palace_name: "",
        master: "",
        address: "",
      });

      setShowPrayerPlaceModal(false);

      Swal.fire({
        title: "Success!",
        text: "Prayer place added successfully.",
        icon: "success",
        confirmButtonText: "Ok",
      });
    } catch (error) {
      console.error(error);

      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "Failed to add prayer place.",
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };
  /*
  |--------------------------------------------------------------------------
  | Video Upload
  |--------------------------------------------------------------------------
  */

  const CHUNK_SIZE = 5 * 1024 * 1024;

  const uploadVideoInChunks = async () => {
    if (!selectedVideo || !religiousAffiliationId) {
      Swal.fire({
        title: "Error!",
        text:
          "Please select a video and save the religious affiliation first.",
        icon: "error",
        confirmButtonText: "Ok",
      });

      return;
    }

    setVideoUploading(true);
    setUploadProgress(0);

    try {
      const totalChunks = Math.ceil(
        selectedVideo.size / CHUNK_SIZE
      );

      for (
        let chunkIndex = 0;
        chunkIndex < totalChunks;
        chunkIndex++
      ) {
        const start =
          chunkIndex * CHUNK_SIZE;

        const end = Math.min(
          selectedVideo.size,
          start + CHUNK_SIZE
        );

        const chunk = selectedVideo.slice(
          start,
          end
        );

        const fd = new FormData();

        fd.append(
          "affiliation_id",
          String(religiousAffiliationId)
        );

        fd.append(
          "chunk_index",
          String(chunkIndex)
        );

        fd.append(
          "total_chunks",
          String(totalChunks)
        );

        fd.append(
          "file_name",
          selectedVideo.name
        );

        fd.append(
          "video_chunk",
          chunk,
          `${chunkIndex}_${selectedVideo.name}`
        );

        await axios.post(
          `${process.env.REACT_APP_API_URL}/religious-affiliation-video-upload`,
          fd,
          {
            headers: {
              "Content-Type":
                "multipart/form-data",
            },
          }
        );

        setUploadProgress(
          Math.round(
            ((chunkIndex + 1) /
              totalChunks) *
            100
          )
        );
      }

      Swal.fire({
        title: "Success!",
        text: "Video uploaded successfully!",
        icon: "success",
        confirmButtonText: "Ok",
      });

      setSelectedVideo(null);
      setUploadProgress(0);
    } catch (error) {
      console.error(error);

      Swal.fire({
        title: "Error!",
        text: "Video upload failed.",
        icon: "error",
        confirmButtonText: "Ok",
      });
    } finally {
     window.location.reload();
      setVideoUploading(false);
    }
  };

  /*
  |--------------------------------------------------------------------------
  | Render
  |--------------------------------------------------------------------------
  */

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                Religious Affiliation
              </h3>

              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link
                    to="#"
                    className="mc-breadcrumb-link"
                  >
                    Home
                  </Link>
                </li>

                <li className="mc-breadcrumb-item">
                  Religious Affiliation
                </li>

                <li className="mc-breadcrumb-item">
                  Add Religious Affiliation
                </li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>

      <Card>
        <Card.Body>
          {!religiousAffiliationId && (
            <Form onSubmit={submitForm}>
              <Row>

                {/* Family */}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Family
                    </Form.Label>

                    <Select
                      options={familyOptions}
                      placeholder="Select Family"
                      isSearchable
                      isClearable
                      value={
                        familyOptions.find(
                          (option) =>
                            Number(option.value) === Number(form.person_id)
                        ) || null
                      }
                      onChange={(option) =>
                        handleChange(option, "person_id")
                      }
                    />

                    {formErrors.person_id && (
                      <div className="text-danger mt-1">
                        {formErrors.person_id}
                      </div>
                    )}
                  </Form.Group>
                </Col>



                {/* Faith */}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Faith
                    </Form.Label>

                    <Form.Select
                      name="faith_id"
                      value={form.faith_id}
                      onChange={handleChange}
                      isInvalid={
                        !!formErrors.faith_id
                      }
                    >
                      <option value="">
                        Select Faith
                      </option>

                      {faiths.map((faith) => (
                        <option
                          key={faith.id}
                          value={faith.id}
                        >
                          {faith.name}
                        </option>
                      ))}
                    </Form.Select>

                    <Form.Control.Feedback type="invalid">
                      {formErrors.faith_id}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                {/* Prayer Place */}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Prayer Place
                    </Form.Label>

                    <Select
                      options={[
                        ...filteredPrayerPlaces.map((place) => ({
                          value: place.id,
                          label: place.palace_name,
                        })),
                        {
                          value: "__add_new__",
                          label: "+ Add New Prayer Place",
                        },
                      ]}
                      placeholder={
                        form.faith_id
                          ? "Select Prayer Place"
                          : "Select Faith First"
                      }
                      isSearchable
                      isClearable
                      isDisabled={!form.faith_id}
                      value={
                        filteredPrayerPlaces
                          .map((place) => ({
                            value: place.id,
                            label: `${place.palace_name} - (${place.address})`,
                          }))
                          .find(
                            (option) =>
                              Number(option.value) === Number(form.place_id)
                          ) || null
                      }
                      onChange={(option) => {
                        if (option?.value === "__add_new__") {
                          setNewPrayerPlace((prev) => ({
                            ...prev,
                            faith_id: form.faith_id,
                          }));

                          setShowPrayerPlaceModal(true);

                          return;
                        }

                        handleChange(option, "place_id");
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.place_id}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                {/* Baptized */}
                {
                  form.faith_id === "2" && (
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Baptized
                        </Form.Label>

                        <Form.Select
                          name="baptized"
                          value={form.baptized}
                          onChange={handleChange}
                        >
                          <option value="0">
                            No
                          </option>

                          <option value="1">
                            Yes
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  )
                }
                {/* Comments */}
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Comments
                    </Form.Label>

                    <Form.Control
                      as="textarea"
                      rows={5}
                      name="comments"
                      value={form.comments}
                      onChange={handleChange}
                      placeholder="Enter comments"
                    />
                  </Form.Group>
                </Col>

              </Row>

              <Button
                type="submit"
                className="mt-3"
              >
                Save Religious Affiliation
              </Button>
            </Form>
          )}

          {/* Gallery after saving */}
          {religiousAffiliationId && (
            <>
              <CardHeader className="m-3">
                <h5 className="text-center mb-3">
                  Upload Picture Gallery
                </h5>
              </CardHeader>

              <GalleryUpload
                religiousAffiliationId={
                  religiousAffiliationId
                }
                images={[]}
              />
            </>
          )}
        </Card.Body>
      </Card>

      {/* Video after saving */}
      {religiousAffiliationId && (
        <Card className="mt-4">
          <Card.Body>
            <CardHeader className="mb-3">
              <h5 className="text-center">
                Upload Religious Affiliation Video
              </h5>
            </CardHeader>

            <Form.Control
              type="file"
              accept="video/*"
              onChange={(e) =>
                setSelectedVideo(
                  e.target.files[0]
                )
              }
            />

            {selectedVideo && (
              <div className="mt-2">
                <small>
                  {selectedVideo.name}
                </small>
              </div>
            )}

            {uploadProgress > 0 && (
              <div className="progress mt-3">
                <div
                  className="progress-bar"
                  style={{
                    width: `${uploadProgress}%`,
                  }}
                >
                  {uploadProgress}%
                </div>
              </div>
            )}

            <Button
              className="mt-3"
              disabled={
                !selectedVideo ||
                videoUploading
              }
              onClick={
                uploadVideoInChunks
              }
            >
              {videoUploading
                ? "Uploading..."
                : "Upload Video"}
            </Button>
          </Card.Body>
        </Card>
      )}
      <Modal

        show={showPrayerPlaceModal}
        onHide={() =>
          setShowPrayerPlaceModal(false)
        }
        centered
      >
        <Modal.Header closeButton className="m-3">

          <Modal.Title>
            Add Prayer Place
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="m-3" style={{ width: '502px' }}>

          {/* Faith */}
          <Form.Group className="mb-3">
            <Form.Label>
              Faith
            </Form.Label>

            <Form.Select
              name="faith_id"
              value={newPrayerPlace.faith_id}
              onChange={(e) => {
                const value = e.target.value;

                setNewPrayerPlace((prev) => ({
                  ...prev,
                  faith_id: value,
                }));

                handleChange(e);
              }}
            >
              <option value="">
                Select Faith
              </option>

              {faiths.map((faith) => (
                <option
                  key={faith.id}
                  value={faith.id}
                >
                  {faith.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* Place Name */}
          <Form.Group className="mb-3">
            <Form.Label>
              Prayer Place Name
            </Form.Label>

            <Form.Control
              type="text"
              placeholder="Enter prayer place name"
              value={
                newPrayerPlace.palace_name
              }
              onChange={(e) =>
                setNewPrayerPlace({
                  ...newPrayerPlace,
                  palace_name: e.target.value,
                })
              }
            />
          </Form.Group>

          {/* Master */}
          <Form.Group className="mb-3">
            <Form.Label>
              Master
            </Form.Label>

            <Form.Control
              type="text"
              placeholder="Enter master name"
              value={
                newPrayerPlace.master
              }
              onChange={(e) =>
                setNewPrayerPlace({
                  ...newPrayerPlace,
                  master: e.target.value,
                })
              }
            />
          </Form.Group>

          {/* Address */}
          <Form.Group className="mb-3">
            <Form.Label>
              Address
            </Form.Label>

            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter address"
              value={
                newPrayerPlace.address
              }
              onChange={(e) =>
                setNewPrayerPlace({
                  ...newPrayerPlace,
                  address: e.target.value,
                })
              }
            />
          </Form.Group>

        </Modal.Body>

        <Modal.Footer className="m-3">
          <Button
            variant="secondary"
            onClick={() =>
              setShowPrayerPlaceModal(false)
            }
          >
            Close
          </Button>

          <Button
            variant="primary"
            onClick={savePrayerPlace}
          >
            Save Prayer Place
          </Button>
        </Modal.Footer>
      </Modal>
    </PageLayout>
  );
}